<template>
  <div>
    <div v-if="step == 0 && dataLoaded">
      <div class="text-h6 mb-2">Identité du participant</div>

      <IdentiteCoureur v-if="bookingStore.inscriptions[0] && ids_selected_parcours.length > 0"
        :ids_parcours="ids_selected_parcours" :item="bookingStore.inscriptions[0]" @incoherence="incoherence"
        @goToNextStep="goToOptionsStep()"></IdentiteCoureur>
    </div>
    <div v-if="step == 1">
      <div>
        <v-btn @click="step = 0" color="primary-dark" class="mt-2" variant="default" size="small"> <v-icon
            icon="mdi-arrow-left-bold"></v-icon> Retour à l'identité du participant </v-btn>
        <h4 class="font-weight-bold my-3"><v-icon icon="mdi-file-document-edit-outline" color="primary"
            size="xs-small"></v-icon> Mon compte Sportips</h4>
        <div v-if="mainStore.authUser.isLogged">
          <div>Connecté en tant que {{ mainStore.authUser.userMail }}</div>

          <v-btn v-if="!onload" color="primary-dark" class="sm-fullwidth mt-4 inscription_btn" variant="tonal"
            @click="post()"> <v-icon icon="mdi-arrow-right-bold"></v-icon> Confirmer le transfert d'inscription </v-btn>

          <v-progress-circular v-else indeterminate color="primary-dark"></v-progress-circular>
        </div>

        <v-row v-else>
          <v-col md="6" cols="12">
            <v-alert class="mb-2">Vous devez vous connecter à votre compte Sportips via le formulaire ci-dessous afin de
              confirmer le transfert de l'inscription.</v-alert>

            <LoginForm></LoginForm>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-dialog width="500" max-width="100%" scroll-strategy="none" v-model="dialog_incoherence">
      <v-card>
        <v-card-text>
          <p>Attention ! Notre système a repéré une possible incohérence dans vos informations personnelles :</p>
          <p v-if="!incoherence_response.nom_valide">Nous avons détecté un prénom dans le champ nom, nous vous invitons
            à vérifier votre saisie puis poursuivre votre inscription.</p>
          <p v-if="!incoherence_response.prenom_valide">Votre prénom n'est pas référencé, nous vous invitons à vérifier
            son orthographe puis poursuivre votre inscription.</p>
          <p v-if="!incoherence_response.sexe_valide">Le sexe sélectionné ne correspond pas au prénom indiqué, nous vous
            invitons à vérifier votre choix (HOMME/FEMME) puis poursuivre votre inscription.</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary-dark" block @click="dialog_incoherence = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import IdentiteCoureur from "@/components/Inscription/IdentiteCoureur.vue";
import LoginForm from "@/components/Authentification/LoginForm.vue";

export default {
  props: ["transferable_inscription"],
  components: { IdentiteCoureur, LoginForm },
  data() {
    return {
      step: 0,

      dialog_incoherence: false,
      incoherence_response: {},
      onload: false,
      dataLoaded: false,
    };
  },

  watch: {
    "transferable_inscription.inscription.id_vague_course"() {
      if (!this.bookingStore?.inscriptions[0]?.list_courses?.list) return;
      for (let i = 0; i < this.bookingStore.inscriptions[0].list_courses.list.length; i++) {
        if (this.bookingStore.inscriptions[0].list_courses.list[i].selected) {
          this.bookingStore.inscriptions[0].list_courses.list[i].vague_selected = this.transferable_inscription.inscription.id_vague_course;
        }
      }
    },
  },

  computed: {
    ...mapStores(useMainStore, useBookingStore),
    ids_selected_parcours() {
      if (this.transferable_inscription.inscription && this.transferable_inscription.inscription.id_course) {
        return [this.transferable_inscription.inscription.id_course];
      }
      return [];
    },
  },
  methods: {
    goToOptionsStep() {
      this.step = 1;
    },

    incoherence(response) {
      if (response) {
        if (!response.nom_valide || !response.prenom_valide || !response.sexe_valide) {
          this.incoherence_response = response;
          this.dialog_incoherence = true;
        }
      }
    },
    async post() {
      this.onload = true;
      const post_request = await this.bookingStore.post_transfert_inscription(this.transferable_inscription);
      if (post_request) {
        this.$router.push({ name: "CheckoutTransfertSuccess" });
      }
      this.onload = false;

    },
  },
  async mounted() {
    this.mainStore.bookingSystem.init();
    await this.mainStore.champs_formulaire.fetch();
    if (this.bookingStore.inscriptions[0].list_courses.list.length == 0) {
      await this.bookingStore.inscriptions[0].list_courses.initialize_from_mainstore(this.mainStore.module.courses.list);
      this.bookingStore.inscriptions[0].add_course_from_preselection(this.transferable_inscription.inscription.id_course);
    }
    if (this.bookingStore.inscriptions[0].list_options.list.length == 0) {
      await this.bookingStore.inscriptions[0].list_options.initialize_from_mainstore(this.mainStore.module.options.list);
      this.bookingStore.inscriptions[0].list_options.add_from_transferable(this.transferable_inscription.inscription);
    }
    if (this.bookingStore.inscriptions[0].list_activites.list.length == 0) {
      await this.bookingStore.inscriptions[0].list_activites.initialize_from_mainstore(this.mainStore.module.activites.list);
      this.bookingStore.inscriptions[0].list_activites.add_from_transferable(this.transferable_inscription.inscription);
    }
    this.dataLoaded = true;

  },
};
</script>

<style lang="scss" scoped></style>